module.exports = __webpack_public_path__ + "img/9-0-0.41ab9548.png";